import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetAiReviewChatQuery = (
  shareToken?: string,
  reviewId?: string,
  refetch?: boolean
) => {
  const { prototypesShare } = useAvApi();

  return useQuery({
    enabled: !!shareToken && !!reviewId,
    queryKey: ['scenario-ai-reviews-chat', shareToken, reviewId],
    queryFn: async () => {
      if (!shareToken || !reviewId) return;
      const data =
        await prototypesShare.getV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewId(
          { shareToken, reviewId }
        );

      return data.data;
    },
    refetchInterval: refetch ? 1000 : undefined,
  });
};
